<template>
    <div>
        <the-header>
            <template v-slot:title>
                {{ $route.meta.title }}
            </template>
            <template v-slot:deliveries>
                <p
                        v-if="totalDeliveries"
                        class="is-size-5"
                >
                    Dostaw: <strong>{{ totalDeliveries }}</strong>
                </p>
                <p class="is-size-5" style="width:110px; margin-left: 2%;">
                    <datepicker
                            v-model="deliveryDate"
                            :config="{
                            dateFormat: 'Y-m-d',
                            static: true,
                            locale: {firstDayOfWeek: 1},
                            altInputClass: 'm-calendar__datePicker m-calendar__datePicker--big',
                            minDate: new Date(Date.now() - 6*24*60*60*1000).toISOString().slice(0,10),
                            maxDate: new Date(Date.now() - 1*24*60*60*1000).toISOString().slice(0,10)
                        }"
                    ></datepicker>
                </p>

            </template>
        </the-header>
        <section class="section">
            <div
                    class="container"
                    v-if="loadingStatus == 'loading'"
            >
                <div class="columns">
                    <div class="column has-text-centered">
                        <br/>
                        <h1 class="title">Trwa pobieranie zamówień</h1>
                        <svg-icon
                                class="svg svg-icon--background svg-icon__icon--loader"
                                type="return"
                        />
                    </div>
                </div>
            </div>
            <div
                    class="container"
                    v-else-if="deliveries && deliveries.length > 0"
            >
                <the-delivery
                        v-for="(delivery, index) in deliveries"
                        v-bind:key="index"
                        :id="index"
                        :delivery="delivery"
                        :isArchive="true"
                />
                <div style="text-align: center; margin-top: 25px" v-if="responseDate">
                    Dane pobrano: {{responseDate}}
                </div>
            </div>
            <div class="container" v-else>
                <div class="columns">
                    <div class="column has-text-centered">
                        <br/>
                        <h1 class="title">Brak zamowień do dostarczenia</h1>
                        <svg-icon
                                class="svg svg-icon--background"
                                type="box"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import TheHeader from '@/components/TheHeader'
    import TheDelivery from '@/components/TheDelivery'
    import SvgIcon from '@/components/SvgIcon'
    import Datepicker from 'vue-bulma-datepicker'

    export default {
        name: 'Deliveries',
        components: {
            'the-delivery': TheDelivery,
            'the-header': TheHeader,
            'svg-icon': SvgIcon,
            'datepicker': Datepicker,
        },
        metaInfo: {
            title: 'Do dostarczenia'
        },
        data() {
            return {
                showModal: true,
                searchText: '',
                state: "close",
            }
        },
        computed: {
            loadingStatus() {
                return this.$store.getters.getLoadingStatus
            },
            deliveryDate: {
                get() {
                    return new Date(Date.now() - 1*24*60*60*1000).toISOString().slice(0,10)
                },
                set(deliveryDate) {
                    this.$store.dispatch('setDeliveryDate', {deliveryDate: deliveryDate})
                }
            },
            deliveries() {
                return this.$store.getters.getPlaned
            },
            totalDeliveries() {
                return this.$store.getters.getTotalPlaned
            },
            responseDate() {
                return this.$store.getters.getResponseDate
            }
        },
        created() {
            this.$store.dispatch('fetchDeliveries')
        },

    }
</script>

<style lang="sass" scoped>
    .section
        padding-bottom: 50vh
</style>
